import React, { Component } from 'react';
import { Text, View, Platform } from 'react-native';

import NavBar from '../../navbar';
import SelectionList from './selection_list';
import OPComponent from '../components/op_component';
import Navigation from '../../navigation';
import { styles } from '../../constants/styles';

export default class GenericSelectionListModal extends OPComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyle;
  static navigatorButtons = NavBar && {
    leftButtons: [NavBar.buttons.done],
  };

  constructor(props) {
    super(props);
  }

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;
    if (NavBar.handleButtonPress(componentId, buttonId)) return;
  };
  componentDidMount() {
    Navigation.registerForButtonEvents(this);
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  handleSelect = (id, item) => {
    if (this.props.closeOnSelect) {
      Navigation.dismissModal(this.props.componentId);
    }
    this.props.setSelected(id, item);
  };

  render() {
    return (
      <View style={styles.containerAlt}>
        <SelectionList
          items={this.props.items}
          selectedId={this.props.selectedId}
          onSelect={this.handleSelect}
        />
      </View>
    );
  }
}
